import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { getDefaultFontSize } from 'hooks/useGetTypographyFonts';
import React from 'react';
import { useIsTablet } from 'hooks/useIsTablet';

export const UiContext = React.createContext({
  spacings: defaultSpacingPresets,
  getFontSize: getDefaultFontSize,
  isMobile: true,
  isTablet: true,
});
